export class BundleSkusModel {
    dcmCode: string;
    socCode: string;
    displayName: string;
    desc: string;
    constructor() {
        this.dcmCode = undefined;
        this.socCode = undefined;
        this.displayName = undefined;
        this.desc = undefined;
    }
};
